import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import useGetShopEmbedHtmlSuspense from "@babackapp/private-api-client/client/use-get-embed-content";

export default function EmbedPage() {
  const [searchParams] = useSearchParams();
  const shopifyUrl = searchParams.get("shop");

  if (!shopifyUrl) {
    throw new Error("shop param is required");
  }

  const { data } = useGetShopEmbedHtmlSuspense(shopifyUrl, true);

  useEffect(() => {
    const scriptFn = new Function(data.script);
    scriptFn();
  }, [data]);

  return <div dangerouslySetInnerHTML={{ __html: data.html }}></div>;
}
